export default "__VITE_ASSET__WFHrEU78LbAH0OIV$gG5mg__"